import { isBRServer } from '@/utils/Validators/validation';

const LINK_NA_BIO = {
  br: [
    {
      id: '01',
      link: 'https://suporte.hostgator.com.br/hc/pt-br/articles/24845439817371-O-que-%C3%A9-e-por-que-ter-um-link-na-bio?utm_source=portal&utm_medium=etapa-1&utm_campaign=O-que-e-por-que-ter-um-link-na-bio&utm_id=linknabio-br',
      question: 'O que é e por que ter um link na bio',
    },
    {
      id: '02',
      link: 'https://suporte.hostgator.com.br/hc/pt-br/articles/24845185786011-Como-criar-um-Link-na-Bio?utm_source=portal&utm_medium=etapa-1&utm_campaign=Como-criar-um-Link-na-Bio&utm_id=linknabio-br',
      question: 'Como criar um Link na Bio',
    },
    {
      id: '03',
      link: 'https://suporte.hostgator.com.br/hc/pt-br/articles/24845208436251-Como-adicionar-meu-Link-na-Bio-nas-redes-sociais?utm_source=portal&utm_medium=etapa-1&utm_campaign=Como-adicionar-meu-Link-na-Bio-nas-redes-sociais&utm_id=linknabio-br',
      question: 'Como adicionar meu Link na Bio nas redes sociais',
    },
    {
      id: '04',
      link: 'https://suporte.hostgator.com.br/hc/pt-br/articles/24845268238235-Como-editar-ou-excluir-meu-Link-na-Bio?utm_source=portal&utm_medium=etapa-1&utm_campaign=Como-editar-ou-excluir-meu-Link-na-Bio&utm_id=linknabio-br',
      question: 'Como editar ou excluir um Link na Bio',
    },
  ],
  es: [
    {
      id: '01',
      link: 'https://soporte.hostgator.mx/hc/es-419/articles/30546503233683-Qu%C3%A9-es-y-por-qu%C3%A9-tener-un-Enlace-en-la-Bio',
      question: 'Qué es y por qué tener un enlace en la biografía.',
    },
    {
      id: '02',
      link: 'https://soporte.hostgator.mx/hc/es-419/articles/30546564989459-C%C3%B3mo-crear-un-Enlace-en-la-Bio',
      question: 'Cómo crear un Enlace en la Bio.',
    },
    {
      id: '03',
      link: 'https://soporte.hostgator.mx/hc/es-419/articles/30546630956435-C%C3%B3mo-agregar-el-Enlace-en-la-Bio-en-las-redes-sociales-Instagram-Facebook-TikTok-YouTube-LinkedIn',
      question: 'Cómo agregar mi enlace de la bio en las redes sociales (Instagram, Facebook, TikTok, YouTube, LinkedIn).',
    },
    {
      id: '04',
      link: 'https://soporte.hostgator.mx/hc/es-419/articles/30546673338003-C%C3%B3mo-editar-o-eliminar-un-Enlace-en-la-Bio',
      question: 'Cómo editar o eliminar el enlace en la Bio.',
    },
  ],
};

const CUSTOM_DOMAIN_LINKS = {
  br: 'https://suporte.hostgator.com.br/hc/pt-br/articles/31201728427539-Como-conectar-um-domínio-registrado-no-Link-na-Bio',
  es: 'https://soporte.hostgator.mx/hc/es-419/articles/31203235769491-Como-conectar-un-dominio-registrado-en-el-Enlace-en-la-Bio',
};

export const FAQ_LINK_NA_BIO = isBRServer ? LINK_NA_BIO.br : LINK_NA_BIO.es;
export const CUSTOM_DOMAIN_TO_LINK_NA_BIO = isBRServer ? LINK_NA_BIO.br : CUSTOM_DOMAIN_LINKS.es;
